<template>
  <div class="preview-shadow" v-if="openModal" @click="close">
    <div class="image-content">
      <!--<button type="button" @click="close">
        <i class="now-ui-icons ui-1_simple-remove"></i>
      </button>-->
      <img alt="" :src="path"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImagePreview",
  data(){
    return {
      path: "",
      openModal: false
    }
  },
  methods: {
    show(img){
      this.path = img;
      this.openModal = true;
    },
    close(){
      this.openModal = false;
    }
  }
}
</script>

<style scoped>
  .preview-shadow {
    position: fixed;
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .image-content {
    position: absolute;
    width: 500px;
    height: 500px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .image-content > img {
    width: 100%;
    height: 100%;
    background: white;
    padding: 4px;
  }
  .image-content > button {
    position: absolute;
    top: 20px;
    right: 20px;
    border-radius: 20px;
    border: solid 1px white;
    background-color: #dedede;
    color: white;
    font-size: 18px;
    width: 35px;
    height: 35px;
    padding-top: 2px;
  }
</style>
